import { createRules, fullNameRegex, activePhoneRegex, activeEmailRegex } from "@hilma/forms";
import { isEmail, isMobilePhone, length } from 'class-validator';

export const schoolAdminRules = createRules({
	name: { required: true, regex: fullNameRegex, greaterThan: 2, smallerThan: 45 },
	phone: { required: true, activeRegex: activePhoneRegex, classValidator: (value: string) => isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10) },
	email: { required: true, activeRegex: activeEmailRegex, classValidator: (value: string) => isEmail(value) },
});

